<template>
  <p style="margin-bottom: 0">
    <span :style="statusColors[status]" class="status-style">
      {{ formatStatus }}
    </span>
    <slot name="pendingReason" />
  </p>
</template>

<script>
  export default {
    name: 'status',
    props: {
      status: {},
    },
    data() {
      return {
        statusColors: {
          Ongoing: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Activated: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Selected: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Planned: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Proposed: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Completed: { background: 'rgba(5, 163, 87, 0.1)', color: '#05A357' },
          Terminated: { background: 'rgba(225, 25, 0, 1)', color: '#FFFFFF' },
          Cancelled: { background: 'rgba(225, 25, 0, 1)', color: '#FFFFFF' },
          'Unknown Legacy Status': { background: 'rgba(244, 240, 244, 1)', color: '#78767A' },
          Concept: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          Pending: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          'Not Pursued': { background: 'rgba(244, 240, 244, 1)', color: '#78767A' },
          CANCELLED: { background: 'rgba(225, 25, 0, 1)', color: '#FFFFFF' },
          COMPLETED: { background: 'rgba(5, 163, 87, 0.1)', color: '#05A357' },
          ONGOING: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          'IN PROGRESS': { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          PLANNED: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          PROPOSED: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
          TERMINATED: { background: 'rgba(225, 25, 0, 1)', color: '#FFFFFF' },
          'UNKNOWN LEGACY STATUS': { background: 'rgba(244, 240, 244, 1)', color: '#78767A' },
          SUBMITTED: { color: '#0064C1', background: 'rgba(0, 100, 193, 0.1)' },
          CLOSED: { color: '#F4F0F4', background: '#78767A' },
          EXPIRED: { color: '#FFDAD4', background: '#E11900' },
          'NOT AVAILABLE YET': { color: '#F4F0F4', background: '#78767A' },
          'SENT FOR PROVISIONING': { color: '#E5EFF9', background: '#0064C1' },
          'TRAINING NOT COMPLETED': { color: '#E5EFF9', background: '#0064C1' },
          PENDING: { color: '#05A357', background: '#E6F6EE' },
          VERIFIED: { color: '#FFFFFF', background: '#05A357' },
          Active: { background: 'rgba(5, 163, 87, 0.1)', color: '#05A357' },
          Inactive: { color: '#F4F0F4', background: '#78767A' },
        },
      };
    },
    computed: {
      formatStatus() {
        return this.status ? this.status.toUpperCase() : null;
      },
    },
  };
</script>

<style></style>
